import Hero from "./hero/Hero";
import About from "./about/About";
import Skills from "./skills/Skills";
import Experiences from "./experiences/Experiences";
import Projects from "./projects/Projects";
import Interests from "./Interests/Interests";

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Skills />
      <Experiences />
      <Projects />
      <Interests />
    </>
  );
};

export default Home;
